export const AUDIT_HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];

export const DEFAULT_AUDIT_FILTERS = {
  moduleKey: '',
  userUuid: '',
  httpMethod: '',
  search: '',
  endpoint: '',
  startDate: '',
  endDate: '',
};

export const DEFAULT_AUDIT_PER_PAGE = 25;

export const DATE_INPUT_FORMAT = 'yyyy-MM-dd';

export const AUDIT_TABLE_COLUMNS = [
  { id: 'created_at', label: 'Fecha/Hora' },
  { id: 'user', label: 'Usuario' },
  { id: 'module', label: 'Módulo' },
  { id: 'description', label: 'Acción registrada' },
  { id: 'status_code', label: 'Estado' },
  { id: 'actions', label: 'Acciones' },
];
